import fetchJSON from '@api/api_helper';

export const destroy = (ruleKey) => {
  const url = () => `/api/v4/rules/${ruleKey}`;
  return fetchJSON(url(), {
    method: 'DELETE'
  }).catch(async (response) => { throw (await response.json()); });
};

export const run = (ruleKey) => {
  const url = () => `/api/v4/rules/${ruleKey}/run`;
  return fetchJSON(url(), {
  }).catch(async (response) => { throw (await response.json()); });
};
